var rtl_default = {
  "rtl": "U3A1d",
  "ltr": "A8sQw"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
